import { TableCell } from '@mui/material';

const BSTableBodyCell = ({ children, ...props }) => {
  return (
    <TableCell
      sx={{
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 1.2
      }}
      {...props}>
      {children}
    </TableCell>
  );
};

export default BSTableBodyCell;
